import React, { useState } from 'react';
import { FaCrown, FaTimes, FaCheck, FaExternalLinkAlt } from 'react-icons/fa';
import { useToast } from '../context/ToastContext';

const UpgradeModal = ({ onClose, onUpgrade }) => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();

  const handleRedeem = async () => {
    if (!code.trim()) {
      showToast('Please enter a redeem code', 'error');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/users/redeem`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ code })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message);
      }

      showToast('Premium activated successfully!', 'success');
      onUpgrade(data.premiumExpiry);
      onClose();
    } catch (error) {
      showToast(error.message, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent flex items-center">
            <FaCrown className="w-6 h-6 mr-2 text-yellow-400" />
            Upgrade to Premium
          </h3>
          <button
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 transition-colors rounded-full hover:bg-gray-100"
          >
            <FaTimes className="w-5 h-5" />
          </button>
        </div>

        <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-6 mb-6">
          <h4 className="text-lg font-semibold text-purple-600 mb-4">Premium Features</h4>
          <ul className="space-y-3">
            {[
              'View sender details (IP, Location etc.)',
              'Priority support',
              'Ad-free experience',
              'Only on 70TK/week'
            ].map((feature, index) => (
              <li key={index} className="flex items-center text-gray-700">
                <FaCheck className="w-4 h-4 text-green-500 mr-2 flex-shrink-0" />
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Redeem Code
            </label>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
              placeholder="Enter your redeem code"
            />
          </div>

          <div className="flex flex-col items-center space-y-4">
            <button
              onClick={handleRedeem}
              disabled={loading}
              className="w-full px-8 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl hover:from-purple-700 hover:to-pink-700 transition-all transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center justify-center"
            >
              {loading ? (
                <span className="animate-spin">⏳</span>
              ) : (
                <>
                  <FaCrown className="w-5 h-5 mr-2" />
                  Activate Premium
                </>
              )}
            </button>

            <a
              href="https://t.me/safone_robot"
              target="_blank"
              rel="noopener noreferrer"
              className="text-purple-600 hover:text-purple-700 flex items-center"
            >
              Buy Redeem Code <FaExternalLinkAlt className="w-4 h-4 ml-1" />
            </a>
          </div>

          <p className="text-sm text-gray-500 text-center mt-4">
            Cancel anytime. Money-back guarantee.
          </p>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal; 